/**
 * Created by Darius on 2016.08.07.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import DomainCellRenderer from "./domain-cell-renderer"
import {AgGridReact, reactCellRendererFactory} from 'ag-grid-react';
import QueueEdit from "./queue-edit";
import ActionDialog from "./action-dialog";
import service from '../../services/dashboard-services';
import {FlatButton} from "material-ui";

class Queues extends Component {
    constructor(props, context) {
        super(props, context);

        this.pause = false;
        this.gridOptions = null;
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.queues && this.gridOptions && !this.pause) {
            console.log("Update queues");
            this.onUpdateRows(nextProps.queues);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        // You can access `this.props` and `this.state` here
        // This function should return a boolean, whether the component should re-render.
        return !(this.gridOptions && this.pause === nextProps.pause);


    }

    onGridReady(options) {
        console.log(options);
        this.gridOptions = options;
        this.gridOptions.api.setRowData([]);

        this.props.onInitialQueues();
    }

    onUpdateRows(newData) {
        const self = this;
        // at the end of the update below, this array will
        // have all of the items that we updated

        const mappedData = {};
        newData.map((row, index) => {
            mappedData[row.Domain] = row;
        });

        const allNodes = {};
        self.gridOptions.api.getRenderedNodes().map((row, index) => {
            allNodes[row.data.Domain] = row;
        });

        let needRefreshAll = false;
        let domainProperty;
        //add new rows if not added
        for (domainProperty in mappedData) {
            if (!allNodes.hasOwnProperty(domainProperty)) {
                needRefreshAll = true;
                break;
            }
        }

        for (domainProperty in allNodes) {
            if (!mappedData.hasOwnProperty(domainProperty)) {
                needRefreshAll = true;
                break;
            }
        }

        if (needRefreshAll) {
            this.gridOptions.api.setRowData(newData);
            console.log('very new data came need full refresh');
            return;
        }

        const updatedNodes = [];
        const cellsToUpdate = [];
        const propertiesToUpdate = {};
        self.gridOptions.api.forEachNode(function (node) {
            const data = node.data;
            const newRow = mappedData[data.Domain];

            for (const property in data) {

                const oldValue = data[property];
                const newValue = newRow[property];

                if (oldValue != newValue) {
                    data[property] = newValue;
                    updatedNodes.push(node);
                    propertiesToUpdate[property] = 1;

                }
            }
        });

        for (const property in propertiesToUpdate) {
            cellsToUpdate.push(property);
        }
        // now tell the grid it needs refresh all these rows
        self.gridOptions.api.refreshCells(updatedNodes, cellsToUpdate);
    }

    queuesColumns() {
        const self = this;
        const defWidth = 80;
        const columnDefs = [
            {
                headerName: 'Domain',
                width: 160,
                pinned: true,
                field: "Domain",
                cellStyle: {paddingTop: 0},
                cellRenderer: reactCellRendererFactory(DomainCellRenderer, this)
            },
            {headerName: 'Status', field: "Status"},
            {headerName: 'Sent', field: "Sent"},
            {headerName: 'Rejects', field: "Rejects"},
            {headerName: 'Failures', field: "Failures"},
            {headerName: 'Queued', field: "Queued"},
            {headerName: 'Queues', field: "Queues"},
            {headerName: 'Newest', field: "Newest"},
            {headerName: 'Oldest', field: "Oldest"},
            {headerName: 'Average', field: "Average"},
            {headerName: 'MaxQueues', field: "MaxQueues", width: 120},
            {headerName: 'MaxPerSession', field: "MaxPerSession", width: 130},
            {headerName: 'MaxPerQueue', field: "MaxPerQueue", width: 120},
            {headerName: 'WaitTime', field: "WaitTime"},
            {headerName: 'MXrefresh', field: "MXrefresh"},
            {headerName: 'Debug', field: "Debug"},
            {headerName: 'Rejected', field: "Rejected"}
        ];
        return columnDefs;
    }

    columnEverythingChanged() {
        console.log('columnEverythingChanged');
    }

    onPause() {
        this.props.onPause(!this.pause);
    }

    render() {
        console.log("render queues");
        const {pause} = this.props;

        this.pause = pause;

        return (
            <div ref="mainComponent" className="ag-material" style={{width: "100%", margin: "auto", height: "600px"}}>
                <FlatButton
                    label={this.pause ? "Play" : "Pause"}
                    primary={true}
                    keyboardFocused={false}
                    onTouchTap={this.onPause.bind(this)}
                />
                <AgGridReact
                    colWidth={100}
                    minColWidth={50}
                    onGridReady={this.onGridReady.bind(this)}
                    columnEverythingChanged={this.columnEverythingChanged.bind(this)}

                    columnDefs={this.queuesColumns()}

                    // or provide props the old way with no binding
                    rowSelection="single"
                    enableSorting="true"
                    enableFilter="true"
                    enableColResize="true"
                />
                <QueueEdit/>
                <ActionDialog/>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    time: state.dashboard.time,
    pause: state.dashboard.pause || false,
    queues: state.dashboard.queues || []
});
const mapDispatchToProps = dispatch => ({
    onInitialQueues: () => dispatch({type: 'INITIAL_QUEUES', payload: service.DashboardServices.getCurrentQueues()}),
    onPause: (pause) => dispatch({type: 'QUEUES_PAUSE', payload: pause})
});

Queues = connect(mapStateToProps, mapDispatchToProps)(Queues);

export default Queues;